import firebase from "firebase/app";
import useSWR from "swr";

import {
  SpwnApiResponse,
  SpwnService,
  SpwnServiceFetchPawBalanceRequest,
} from "@spwn-portal/grpc";

import { useConnectClient } from "../../utility/connectWeb";

export const FetchPawBalanceKey = "fetchPawBalance";

export const useEmoBalance = () => {
  const auth = firebase.auth();
  const connectClient = useConnectClient(SpwnService);

  const { data } = useSWR(
    auth.currentUser?.emailVerified ? FetchPawBalanceKey : null,
    async () => {
      const response = await connectClient.fetchPawBalance(
        new SpwnServiceFetchPawBalanceRequest()
      );

      if (response.status !== SpwnApiResponse.SUCCESS) {
        return {
          status: response.status,
        };
      }

      return {
        status: response.status,
        data: {
          balance: response.data?.balance ? Number(response.data.balance) : 0,
        },
      };
    }
  );

  return {
    freeValue: 0,
    paidValue: data?.data?.balance ?? 0,
  };
};
